import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var LogsService = /** @class */ (function () {
    function LogsService(http) {
        this.http = http;
        this.url = 'task-logs';
    }
    LogsService.prototype.list = function (params) {
        return this.http.get(this.url, { params: params });
    };
    LogsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LogsService_Factory() { return new LogsService(i0.ɵɵinject(i1.HttpClient)); }, token: LogsService, providedIn: "root" });
    return LogsService;
}());
export { LogsService };
